import {UIModule} from "./ui-module.model";

export interface BiometricsAuthenticateData {
  application?: string;
  uiModule?: UIModule;
  request?: string;
  biometricsLoginUUID?: string;
  customDeviceName?: string;
  status?: string;
  mode?: string;
  credential?: string;
}

export enum BiometricsAuthenticationStatus {
  REGISTRATION_STARTED = "REGISTRATION_STARTED",
  REGISTRATION_COMPLETE = "REGISTRATION_COMPLETE",
  AUTHENTICATION_STARTED = "AUTHENTICATION_STARTED",
  USER_AUTHENTICATED = "USER_AUTHENTICATED",
  HARD_AUTH_NEEDED = "HARD_AUTH_NEEDED",
}

export enum BiometricsAuthenticationMode {
  START_REG = "START_REG",
  FINALIZE_REG = "FINALIZE_REG",
  START_AUTH = "START_AUTH",
  FINALIZE_AUTH = "FINALIZE_AUTH",
}
